import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    icon: '📖',
    title: 'Abrís el material',
    desc: 'Sin pensar. Sin planificar'
  }, {
    icon: '👆',
    title: 'Elegís qué comer',
    desc: 'Todo ya está organizado'
  }, {
    icon: '🔥',
    title: 'Seguís el sistema',
    desc: 'Y empezás a ver resultados'
  }];
  return <section className="py-16 px-4 bg-black text-white" data-id="element-92">
      <div className="max-w-5xl mx-auto" data-id="element-93">
        <div className="text-center mb-12" data-id="element-94">
          <h2 className="text-4xl md:text-5xl font-black text-yellow-400 mb-4 uppercase" data-id="element-95">
            ⚡ Así de simple funciona
          </h2>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-4 relative" data-id="element-96">
          {steps.map((step, index) => <Fragment key={index} data-id="element-97">
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="bg-gray-900 p-8 rounded-2xl border border-gray-800 w-full md:w-1/3 text-center relative z-10 shadow-2xl" data-id="element-98">
                <div className="text-6xl mb-4" data-id="element-99">{step.icon}</div>
                <h3 className="text-2xl font-bold mb-2 text-white" data-id="element-100">
                  {step.title}
                </h3>
                <p className="text-gray-400 font-medium" data-id="element-101">{step.desc}</p>
              </motion.div>

              {index < steps.length - 1 && <div className="hidden md:block text-4xl text-yellow-400 z-0" data-id="element-102">
                  ➔
                </div>}
              {index < steps.length - 1 && <div className="md:hidden text-4xl text-yellow-400 rotate-90 my-2" data-id="element-103">
                  ➔
                </div>}
            </Fragment>)}
        </div>
      </div>
    </section>;
}